<template>
  <div>
    <el-container>
      <el-aside width="200px">
        <div class="asideBody">
          <div style="height: 60px; margin-bottom: 30px; background: #018197;"></div>
          <el-menu :default-active="activeIndex"
                   background-color="#01788c"
                   text-color="#fff"
                   class="el-menu-vertical-demo"
                   active-text-color="#01aca8"
                   @select="handleSelect"
                   router>
            <el-menu-item style="text-align: left;" index="/Stable">
              <i class="el-icon-menu"></i>
              <span>稳态电气量</span>
            </el-menu-item>
            <el-menu-item style="text-align: left;" index="/Trend">
              <i class="el-icon-menu"></i>
              <span>系统趋势</span>
            </el-menu-item>
            <el-menu-item style="text-align: left;" index="/Transient">
              <i class="el-icon-menu"></i>
              <span>暂态电气量</span>
            </el-menu-item>
            <el-menu-item style="text-align: left;" index="/Event">
              <i class="el-icon-menu"></i>
              <span>电能质量事件</span>
            </el-menu-item>
            <el-menu-item style="text-align: left;" index="/Speed" v-if="reqMode==='udp'">
              <i class="el-icon-menu"></i>
              <span>高速采样</span>
            </el-menu-item>
            <el-menu-item style="text-align: left;" index="/Realtime">
              <i class="el-icon-menu"></i>
              <span>实时波形</span>
            </el-menu-item>
            <el-menu-item style="text-align: left;" index="/Device">
              <i class="el-icon-menu"></i>
              <span>硬件查询</span>
            </el-menu-item>
            <el-submenu style="text-align: left;" index="Quality" v-if="reqMode==='uart'">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span>历史数据</span>
              </template>
              <el-menu-item index="power" :route='{path:"/History",query:{dataType:"1"}}'>功率</el-menu-item>
              <el-menu-item index="pf" :route='{path:"/History",query:{dataType:"2"}}'>功率因数</el-menu-item>
              <el-menu-item index="voltageRms" :route='{path:"/History",query:{dataType:"3"}}'>有效值
              </el-menu-item>
              <el-menu-item index="voltageThd" :route='{path:"/History",query:{dataType:"4"}}'>谐波畸变率
              </el-menu-item>
              <el-menu-item index="currentRms" :route='{path:"/History",query:{dataType:"5"}}'>三相不平衡度
              </el-menu-item>
              <el-menu-item index="currentThd" :route='{path:"/History",query:{dataType:"6"}}'>电度计量
              </el-menu-item>
              <!--              <el-menu-item index="eventLog" :route='{path:"/History",query:{dataType:"7"}}'>电能质量事件记录-->
              <!--              </el-menu-item>-->
            </el-submenu>
            <!--            <el-submenu style="text-align: left;" index="Quality">-->
            <!--              <template slot="title">-->
            <!--                <i class="el-icon-menu"></i>-->
            <!--                <span>电能质量</span>-->
            <!--              </template>-->
            <!--              <el-menu-item-group>-->
            <!--                <el-menu-item index="/Realtime">实时监控</el-menu-item>-->
            <!--              </el-menu-item-group>-->
            <!--            </el-submenu>-->
          </el-menu>
        </div>
      </el-aside>
      <el-container>
        <el-header>
          <div class="headerBody" style="display: flex; justify-content: space-between">
            <div class="headerTitlePnl">江苏斯帕沃电子技术有限公司综合电能质量监控系统</div>
            <div style="width: 35%; color: #3a3939; display: flex; justify-content: right">
              <div
                style="width: 300px; display: flex; justify-content: end; align-items: center; margin-left: 30px; text-align: right">
                <div>当前时刻</div>
                <div style="margin-left: 20px">{{ nowDt }}</div>
              </div>
            </div>
            <div style="width: 300px; color: #3a3939; display: flex; justify-content: center; align-items: center"
                 v-if="reqMode==='uart'">
              <el-radio-group v-model="speedMode" size="medium" fill="#01aaa6">
                <el-radio-button label="普通模式"></el-radio-button>
                <el-radio-button label="快速模式"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="color: #3a3939; width: 20%; display: flex; align-items: center; justify-content: center">
              <div @click="centerDialogVisible = true" v-if="reqMode==='uart'">
                <el-button size="medium">选择设备</el-button>
              </div>
              <div style="display: flex; align-items: center"
                   v-if="reqMode==='udp'">
                <div style="width: 10px; height: 10px; background: green; border-radius: 50%; margin-right: 5px"></div>
                <div>设备已连接</div>
              </div>
            </div>
            <div style="color: #3a3939; width: 20%; display: flex; align-items: center; justify-content: center">
              <div @click="loginout" v-if="reqMode==='uart'">
                <el-button size="medium">退出登录</el-button>
              </div>
            </div>
          </div>
          <el-dialog
            :title="reqMode === 'uart'?'请选择设备':'配置以太网'"
            :visible.sync="centerDialogVisible"
            width="30%"
            :modal-append-to-body="false"
            center>
            <div>
              <span style="display: flex; align-items: center" v-if="reqMode === 'uart'">
                <el-input v-model="name" placeholder="请输入内容"></el-input>
                <el-button style="margin: 0 30px; height: 32px;" @click="getDevices">搜索</el-button>
              </span>
              <div style="height: 300px">
                <div v-for="(item, index) in devices" :key="index" style="margin: 20px 10px;">
                  <el-radio v-model="sn" :label="item.sn">{{ item.name }}</el-radio>
                </div>
              </div>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-around">
<!--              <input type="text" v-model="netName">-->
              <!--              <el-button @click="getNetHandle(1)">1</el-button>-->
              <div v-if="reqMode === 'udp'">
                  <el-button @click="disconnectNet" size="medium">还原配置</el-button>
                  <el-button @click="connectNet" size="medium" type="primary">配置网络</el-button>
              </div>
              <!--              <el-button @click="getNetHandle(4)">4</el-button>-->
              <!--              <el-button @click="getNetHandle(5)">5</el-button>-->
              <div v-if="reqMode === 'uart'">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="chooseDevice">确 定</el-button>
              </div>
            </span>
          </el-dialog>
        </el-header>
        <el-main>
          <div class="mainBody">
            <div class="mainTitlePnl"></div>
            <div class="pages">
              <router-view></router-view>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {formatTime} from '../../utils'

export default {
  name: 'Index',
  data () {
    return {
      activeIndex: '/Comp',
      devices: [],
      name: '',
      centerDialogVisible: false,
      sn: '',
      nowDt: '2022/06/08 00:00:00',
      speedMode: '普通模式',
      netName: ''
      // way: 0
    }
  },
  computed: {
    reqMode () {
      return this.$store.state.reqMode
    }
  },
  watch: {
    speedMode (val) {
      if (val === '普通模式') {
        if (this.$store.state.highSpdMode) {
          this.$api.command({
            sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
            lists: [[1, 6, 0xff]]
          }).then(res => {
            console.log('EEE')
            console.log(res)
            if (res.data.code !== 0) {
              this.$message.error(res.data.msg)
            }
          })
        }
      }
      this.$store.commit('updateSpeedMode', val)
    },
    '$store.state.highSpdMode' (val) {
      if (!val) {
        this.speedMode = '普通模式'
        this.$api.command({
          sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
          lists: [[1, 6, 0xff]]
        }).then(res => {
          console.log('FFF')
          console.log(res)
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
          }
        })
      }
    }
  },
  mounted () {
    this.activeIndex = window.sessionStorage.getItem('nowPath') || '/Comp'
    let sn = window.localStorage.getItem('sn')
    if (sn) {
      this.sn = sn
      this.$store.commit('updateSn', this.sn)
    } else {
      if (this.reqMode === 'udp') {
        this.sn = '1'
        this.$store.commit('updateSn', this.sn)
      } else {
        this.centerDialogVisible = true
      }
    }

    if (this.reqMode === 'udp') {
      // this.setNetConf()
    } else {
      this.getDevices()
    }
    this.timeFn()
    // this.getWay()
  },
  methods: {
    loginout () {
      this.$router.push('/Login')
      localStorage.clear()
    },

    handleSelect (key, keyPath) {
      this.activeIndex = key
      window.sessionStorage.setItem('nowPath', key)
    },

    getDevices () {
      this.$api.getDevices({
        'code': window.localStorage.getItem('mix_code'),
        'name': this.name,
        'size': 50,
        'product': '电能质量'
      }).then(({data: res}) => {
        this.devices = res.data.list
      })
    },

    // async getNetHandle (index) {
    //   const {data: res} = await this.$api.command({
    //     sn: this.sn,
    //     lists: [[1, 7, index]]
    //   })
    //   console.log('GGG')
    //   console.log(res)
    //   if (res.code !== 0) {
    //     this.$message.error(res.msg)
    //   }
    //   console.log('aaa', res.data)
    //   return res.data
    // },

    // async udpTest () {
    //   const {data: res} = await this.$api.queryTestUdp({})
    //   // console.log(145, res.data)
    //   console.log('DDD')
    //   console.log(res)
    //   if (res.code !== 0) {
    //     this.$message.error(res.data.msg)
    //     return false
    //   }
    //   if (res.data) {
    //     this.$message.success('udp连接成功')
    //   } else {
    //     this.$message.error('udp连接失败')
    //   }
    //   return res.data
    // },

    // async setNetConf () {
    //   var udpTest = await this.udpTest()
    //   if (udpTest) {
    //     this.centerDialogVisible = false
    //   } else {
    //     // this.centerDialogVisible = true
    //     var netList = await this.getNetHandle(1)
    //     for (var i = 0; i < netList.length; i++) {
    //       netList[i].sn = netList[i].name
    //     }
    //     this.devices = netList
    //   }
    // },

    // async connectNet () {
    //   const getConfig = await this.getNetHandle(4)
    //   // console.log(dhcp, dhcp.typeof)
    //   if (getConfig.dhcp) {
    //     const netStatus = await this.getNetHandle(2)
    //     if (netStatus.dhcp) {
    //       this.$message.error('配网失败')
    //       return
    //     } else {
    //       this.$message.success('配网成功')
    //     }
    //   }
    //   // this.centerDialogVisible = false
    //   // await this.udpTest()
    //   var udpTest = await this.udpTest()
    //   if (udpTest) {
    //     this.centerDialogVisible = false
    //   }
    // },

    // async disconnectNet () {
    //   await this.getNetHandle(3)
    //   const getConfig = await this.getNetHandle(4)
    //   if (getConfig.dhcp) {
    //     this.$message.success('还原成功')
    //   }
    // },

    async chooseDevice () {
      window.localStorage.setItem('sn', this.sn)
      this.$store.commit('updateSn', this.sn)
      this.centerDialogVisible = false
      // this.getWay()
    },

    timeFn () {
      this.timing = setInterval(() => {
        this.nowDt = formatTime(new Date(), 'yyyy/MM/dd HH:mm:ss')
      }, 1000)
    }
    // async getWay () {
    //   const params = {
    //     'collection': 'mix_data',
    //     'sn': this.sn,
    //     'fields': ['way']
    //   }
    //   const {data: {data: {way}}} = await this.$api.queryLastData(params)
    //   this.way = way
    // }
  }
}
</script>

<style scoped>
.el-header {
  background-color: #e3e8ee;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-aside {
  /*background-color: #D3DCE6;*/
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  /*line-height: 160px;*/
  padding: 0;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.el-menu {
  border: none !important;
}

.asideBody {
  width: 100%;
  height: 100vh;
  background: #01788c;
}

.headerBody {
  width: 100%;
  height: 100%;
  color: #fff;
  font-family: Helvetica Neue;
}

.mainBody {
  width: 100%;
  height: 100%;
//color: #fff; overflow: hidden;
}

.headerTitlePnl {
  width: 45%;
  height: 100%;
  font-size: 26px;
  text-align: left;
  padding: 0 0 0 25px;
  color: #01aca8;
  /*border-left: 3px solid #01aca8;*/
}

.mainTitlePnl {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #d0d0d0;
}

.pages {
  width: 100%;
  height: calc(100% - 30px);
}
</style>



// WEBPACK FOOTER //
// src/pages/Index/Index.vue